$(function () {
  const slickSwiper = $(".home-news-carousel .slick-instance");

  //@ts-ignore
  slickSwiper.slick({
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    infinite: true,
    dots: true,
    dotsClass: "slick-dots",
  });

  $(".home-news-carousel .prev-carousel").click(function () {
    //@ts-ignore
    slickSwiper.slick("slickPrev");
  });

  $(".home-news-carousel .next-carousel").click(function () {
    //@ts-ignore
    slickSwiper.slick("slickNext");
  });
});
